<template>
  <div>
    <div v-if="$auth.policies['view-teaching-plan-list']">
      <div>
        <div class="pa-4 d-flex justify-space-between align-center">
          <div>
            <Breadcrumbs
              headline="Kế hoạch giảng dạy"
              :link="[
                {
                  text: 'Kế hoạch giảng dạy',
                  href: '../teaching-plan',
                },
              ]"
            />
          </div>
          <div class="flex-center">
            <div class="d-flex align-center gap-4 mb-2" style="justify-self: right">
              <div class="teaching-plan-status" @mouseover="showHistory = true" @mouseleave="showHistory = false">
                {{ statusText }}
                <div class="history-dropdown">
                  <v-list v-if="showHistory && teachingPlanConfig.history && teachingPlanConfig.history.length">
                    <v-list-item v-for="(item, index) in teachingPlanConfig.history" :key="index">
                      <v-list-item-content>
                        <v-list-item-title> {{ item.user.name }} - {{ item.action }} </v-list-item-title>
                        <v-list-item-subtitle>
                          {{ item.timestamp }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
              </div>

              <v-btn
                class="ml-5"
                outlined
                :color="teachingPlanConfig.isOpen ? 'error' : 'success'"
                @click="toggleRegistration"
              >
                <v-icon left>{{ teachingPlanConfig.isOpen ? 'mdi-lock' : 'mdi-lock-open' }}</v-icon>
                {{ teachingPlanConfig.isOpen ? 'Đóng khai' : 'Mở khai' }}
              </v-btn>
            </div>
          </div>
        </div>

        <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
          <TeachingPlanFilter @onFilterChanged="onFilterChange" />
        </v-card>

        <v-card outlined class="mx-4 elevation-0">
          <TeachingPlanDataTable ref="teachingPlanDataTable" />
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import TeachingPlanDataTable from '@/modules/teachingPlan/TeachingPlanDataTable.vue'
import TeachingPlanFilter from '@/modules/teachingPlan/TeachingPlanFilter.vue'

export default {
  components: {
    Breadcrumbs,
    TeachingPlanDataTable,
    TeachingPlanFilter,
  },
  props: {},
  data() {
    return {
      showHistory: false,
    }
  },
  computed: {
    ...mapState('TeachingPlan', ['teachingPlanConfig']),
    statusText() {
      if (!this.teachingPlanConfig.history || !this.teachingPlanConfig.history.length) {
        return 'Chưa có lịch sử khai'
      }
      const lastAction = this.teachingPlanConfig.history[0]
      return `${lastAction.action} vào ${lastAction.timestamp}`
    },
  },
  methods: {
    ...mapActions('TeachingPlan', ['fetchTeachingPlanConfig', 'toggleRegistrationStatus']),
    async toggleRegistration() {
      await this.toggleRegistrationStatus()
    },
    async refresh(query) {
      this.$refs.teachingPlanDataTable.refresh(query)
    },
    onFilterChange(query) {
      this.refresh(query)
    },
  },
  async created() {
    await this.fetchTeachingPlanConfig()
  },
}
</script>
<style scoped>
.teaching-plan-status {
  position: relative;
  display: inline-block;
  cursor: pointer;
  font-weight: normal;
  transition: color 0.3s ease;
}
.history-dropdown {
  position: absolute;
  top: 30px; /* Ngay dưới dòng status */
  left: 0;
  z-index: 10;
  width: 300px;
  background-color: white;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  overflow: hidden;
}
.history-dropdown v-list {
  max-height: 250px;
  overflow-y: auto;
}

.v-list-item {
  cursor: default;
}

.v-list-item:hover {
  background-color: #f9f9f9;
}
</style>
